<template>
  <!-- 菜单管理 -->
  <div class="wrapper">
    <!-- <el-tabs v-model="menuModule" @tab-click="handleClick">
      <el-tab-pane v-for="item in MENU_MODULE" :key="item.value" :label="item.name" :name="item.value"></el-tab-pane>
    </el-tabs> -->
    <admin-title :title="$route.meta.name"></admin-title>
    <div class="btn-group">
      <div></div>
      <div>
        <el-button
          v-checkbtn="isShowBtn(AUTH_BTN.menu_list_add)"
          type="primary"
          size="mini"
          icon="el-icon-plus"
          @click="$router.push({ name: 'MenuAdd' })"
          >新增</el-button
        >
      </div>
    </div>
    <el-table
      :data="list"
      row-key="id"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      :header-row-style="{ height: '50px', color: '#626e7c' }"
      :cell-style="changeTr"
      :header-cell-style="changeHeader"
    >
      <el-table-column label="名称" align="left" width="300px">
        <template slot-scope="scope">
          {{ scope.row.menuName }}
        </template>
      </el-table-column>
      <el-table-column label="菜单类型" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.menuType == 1" type="success">目录</el-tag>
          <el-tag v-if="scope.row.menuType == 2" type="info">菜单</el-tag>
          <el-tag v-if="scope.row.menuType == 3" type="warning">按钮</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="路由类型" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.linkType == 1">内链</el-tag>
          <el-tag v-if="scope.row.linkType == 2" type="danger">外链</el-tag>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-link v-checkbtn="isShowBtn(AUTH_BTN.menu_list_add)" :underline="false" type="primary" @click="goAdd(scope.row)">新增</el-link>
          <el-link v-checkbtn="isShowBtn(AUTH_BTN.menu_list_edit)" :underline="false" style="margin:0 10px" type="primary" @click="goEdit(scope.row)"
            >编辑</el-link
          >

          <el-link
            v-checkbtn="isShowBtn(AUTH_BTN.menu_list_del)"
            @click="apiDelMenu(scope.row.id)"
            :underline="false"
            style="margin-left:10px"
            type="danger"
          >
            删除
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <!-- :header-cell-style="{ background: '#f8f9fb', padding: '8px 0' }" -->
  </div>
</template>

<script>
import { getMenusTree, delMenu, getModuleList } from './api'
import { authBtnMixin } from '@/mixins/authBtnMixin'
export default {
  name: 'Index',
  mixins: [authBtnMixin],
  data() {
    return {
      list: [],
      total: 0
    }
  },
  provide() {
    return {
      context: this
    }
  },
  mounted() {},
  activated() {
    this.apiQueryMenuTree()
  },
  methods: {
    // 新增一级菜单
    goAddRootMenu() {
      this.$router.push({ name: 'MenuDetail' })
    },
    // 新增子菜单
    goAdd(row) {
      const { id, parentId } = row
      this.$router.push({
        name: 'MenuAdd',
        params: {
          menuId: id,
          parentId
        }
      })
    },
    goEdit(row) {
      const { id } = row
      this.$router.push({ name: 'MenuEdit', params: { menuId: id } })
    },
    async apiQueryMenuTree() {
      let res = await getMenusTree()
      this.list = res || []
    },

    async apiDelMenu(id) {
      this.$confirm('此操作将永久删除该菜单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delMenu(id).then(() => {
            this.apiQueryMenuTree()
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 修改第一列无children的样式
    changeTr({ row, column, rowIndex, columnIndex }) {
      if (!row.children && columnIndex == 0) {
        return { paddingLeft: '100px' }
      }
      if (columnIndex == 0) {
        return { paddingLeft: '100px' }
      }
    },
    changeHeader({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return { background: '#f8f9fb', padding: '8px 0 0 130px' }
      } else {
        return { background: '#f8f9fb', padding: '8px 0' }
      }
    },
    handleClick(val) {
      this.apiQueryMenuTree()
    }
    // async getModuleList() {
    //   this.MENU_MODULE = await getModuleList()
    // }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  /deep/.one-line {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
  }

  // .el-table /deep/ {
  //   border-top-left-radius: 5px;
  //   border-top-right-radius: 5px;
  // }
  .btn-group {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
}
</style>
